<div class="info-list py-3" [ngClass]="{ freemium: isFreemium }">
  <app-app-info-list-item [label]="'Owner'" [value]="data?.riskOverview?.whoisInfo?.owner"
    (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <ng-container *ngIf="data?.riskOverview?.whoisInfo?.emailAddress !== 'N/A'">
    <app-app-info-list-item [label]="'Email Address'" [showFreemiumLock]="isFreemium && !isFollowing"
      [canRouteToDiscovery]="_user.domainSearchEnabled()"
      [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
      [discoveryQueryParams]="{'registrantEmail' : data?.riskOverview?.whoisInfo?.emailAddress}"
      [value]="data?.riskOverview?.whoisInfo?.emailAddress" (goToSectionClick)="goToSection($event)">
    </app-app-info-list-item>
    <div class="divider"></div>
  </ng-container>
  <app-app-info-list-item [label]="'Contact Number'" [showFreemiumLock]="isFreemium && !isFollowing"
    [value]="data?.riskOverview?.whoisInfo?.contactNumber" (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Mailing Address'" [showFreemiumLock]="isFreemium && !isFollowing"
    [value]="data?.riskOverview?.whoisInfo?.mailingAddress" (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
</div>